import React from 'react';

interface FilterTabsProps {
    selectedFilter: string;
    onFilterChange: (filter: string) => void;
    invitationCount?: number;
    grantedCount?: number;
}

const FilterTabs: React.FC<FilterTabsProps> = ({ selectedFilter, onFilterChange, invitationCount, grantedCount }) => {
    const filters = ['Tous', 'Favoris', 'Accès accordé', 'Invitations'];

    const getLabel = (filter: string) => {
        if (filter === 'Invitations' && invitationCount !== undefined) {
            return `${filter} (${invitationCount})`;
        }
        if (filter === 'Accès accordé' && grantedCount !== undefined && grantedCount > 0) {
            return `${filter} (${grantedCount})`;
        }
        return filter;
    };

    return (
        <div className="flex flex-wrap gap-2">
            {filters.map((filter) => (
                <button
                    key={filter}
                    className={`
                        px-4 py-2 rounded-md text-sm flex-1 sm:flex-none
                        transition-all duration-200 shadow-inner
                        ${selectedFilter === filter
                            ? 'bg-mcdm-green-400 dark:bg-mcdm-green-400 text-white dark:text-mcdm-primary-100 hover:bg-mcdm-green-500 dark:hover:bg-mcdm-green-500'
                            : 'bg-white dark:bg-mcdm-third-400 text-mcdm-third-500 dark:text-mcdm-primary-200 hover:bg-mcdm-green-200 dark:hover:bg-mcdm-green-300'
                        }
                    `}
                    onClick={() => onFilterChange(filter)}
                >
                    {getLabel(filter)}
                </button>
            ))}
        </div>
    );
};

export default FilterTabs;